<template lang="html">

  <section>

    <div class="politicas">

      <section class="middle-intro row-start">

        <div class="container">
          <h1 class="title -intro">Política de privacidad</h1>
        </div>

      </section>

      <div class="container">

        <h2 class="title">Tratamiento de datos de carácter personal</h2>

        <p>En cumplimiento con lo dispuesto en la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de Carácter Personal, te informamos de que los datos personales e información que nos facilites al cumplimentar cualquier formulario electrónico disponible en la página web de Innopulse, serán incorporados en un fichero de datos de carácter personal de nuestra titularidad.</p>

        <p>La finalidad del tratamiento de tu información es dar curso a tu solicitud y nunca serán transmitidos a terceros.</p>

        <p>Además, los formularios que se encuentran en la página web de Innopulse, contarán con la posibilidad del usuario de suscribirse a la recepción de boletines de noticias comerciales de Innopulse. En caso de prestar tu consentimiento expreso, podremos enviarte comunicaciones comerciales por cualquier medio, principalmente mediante correo electrónico.</p>
        <p>Cualquier comunicación comercial vía email, mensaje digital u “ordinario” que recibas, se hará en virtud de tu aceptación previa y expresa de nuestra Política de Privacidad y contendrá información relacionada con la actividad y los servicios ofrecidos por Innopulse. No queremos ser spam.</p>

        <h2 class="title">Medidas de seguridad</h2>

        <p>Adoptamos todas las medidas de seguridad que están disponibles en el estado de la tecnología y que nos exige el Reglamento de desarrollo de la Ley de Protección de Datos de Carácter Personal, y ponemos todos los medios que están a nuestro alcance para evitar accesos o tratamientos fraudulentos a los datos por parte de terceros, así como su alteración o pérdida.</p>
        
        <h2 class="title">Políticas de cookies</h2>
        <p>Por favor consulta nuestra Política de Cookies.</p>

        <h2 class="title">Derechos Arco</h2>
        <p>Puedes ejercer tus derechos de Acceso, Rectificación, Cancelación y Oposición (ARCO) enviándonos un email a lopd@Innopulse.es o mediante carta dirigida a Dos Puntos an Internet Company, S.L., C/Fuencarral 119, 3ºB, 28010 Madrid (España).</p>
        <p>Necesitamos que nos indiques en esta carta o email tu nombre y apellidos, dirección email, teléfono y copia de documento de identidad (DNI, NIE, o Pasaporte).</p>
        <p>Puedes consultar información sobre tus derechos pinchando aquí.</p>
        <h2 class="title">Modificación</h2>
        <p>Nos reservamos la posibilidad de modificar esta política de privacidad para adaptarla a nuevas necesidades, obligaciones legales o criterios de la Agencia Española de Protección de Datos. Toda modificación será debidamente comunicada en la página web de Innopulse, en esta sección de Política de Privacidad.</p>
      </div>

    </div>

  </section>

</template>

<script lang="js">
  export default  {
    name: 'politica-de-privacidad',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped >
.politica-de-privacidad {

}
</style>



// WEBPACK FOOTER //
// src/components/views/politica-de-privacidad.vue